module.exports = __webpack_public_path__ + "img/1440.570be4b8.jpg";